import React from 'react';
import { Lock } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function PriceBlock() {
  return <section id="precio" className="py-20 md:py-32 px-4 bg-gradient-to-b from-brand-dark to-brand-darker relative overflow-hidden" data-id="element-127">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-brand-amber/5 blur-[150px] rounded-full pointer-events-none" data-id="element-128" />

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-129">
        <FadeIn data-id="element-130">
          <p className="text-xl md:text-2xl text-white mb-8 font-serif italic" data-id="element-131">
            Recupera tu soberanía mental por menos de lo que cuesta una sola
            sesión de terapia.
          </p>

          <div className="bg-brand-slate/40 border border-brand-amber/20 rounded-3xl p-8 md:p-12 backdrop-blur-sm mb-8 shadow-2xl shadow-black/50" data-id="element-132">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-133">
              Libérate del Apego Emocional en 21 Días
            </h3>
            <p className="text-brand-text/70 mb-8" data-id="element-134">por Freddy Pimentel</p>

            <div className="flex justify-center mb-8" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/73QD363viLVrTUdU76t36T/heylloyd-image-1775686215728.png" alt="Libérate del Apego Emocional en 21 Días - Vista previa del curso" className="w-64 md:w-80 rounded-2xl shadow-lg shadow-black/30" data-id="element-136" />
            </div>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-137">
              <span className="text-2xl text-brand-muted line-through decoration-brand-danger/50" data-id="element-138">
                $150 USD
              </span>
              <span className="text-5xl md:text-6xl font-bold text-brand-amber" data-id="element-139">
                $6.99 USD
              </span>
            </div>

            <div className="flex justify-center" data-id="element-140">
              <CTAButton className="py-5 text-lg" href="https://www.seresconsciente.com/cart/46433440956587:1" data-id="element-141" />
            </div>

            <div className="flex items-center justify-center gap-2 text-brand-muted text-sm mt-6" data-id="element-142">
              <Lock className="w-4 h-4" data-id="element-143" />
              <span data-id="element-144">Pago seguro y privado.</span>
            </div>

            <p className="mt-3 text-sm text-brand-text/60" data-id="element-145">
              Acceso inmediato tras el pago.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}